module.exports = __webpack_public_path__ + "media/אבא.f0737952.mp3";